import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { TitleWrapper } from './journey-detailed.styled';

// interface IProps {
//   journeyName: string
// }

export const Title = () => {
  const [t] = useTranslation();

  return (
    <TitleWrapper id="title-component__pages-journey-detailed__titlewrapper__l14">
      <Typography id="title-component__pages-journey-detailed__typography__l15" variant="h1">{t('journey-header-title')}</Typography>
      {/* <TwitterShare title={journeyName} /> */}
    </TitleWrapper>);

};